import React, { Fragment } from 'react'

import { DesktopOnly, Responsive } from 'ui/acro'
import { categories } from '../_media'

import CenteredInfoSection from '../CenteredInfoSection'
import CategoriesCarousel from './CategoriesCarousel'
import CategoriesResponsive from './CategoriesResponsive'

const Categories = ({ ...rest }) => (
  <Fragment>
    <CenteredInfoSection
      headline='FIND WHAT MOVES YOU'
      body='Whether you’re a complete beginner or you want to step up your routine, get the full studio experience at home with thousands of classes for body, mind, and spirit.'
      {...rest}
    />
    <DesktopOnly mt='68px'>
      <CategoriesResponsive categories={categories} />
    </DesktopOnly>
    <Responsive show={[true, true, false]} mt='68px'>
      <CategoriesCarousel categories={categories} />
    </Responsive>
  </Fragment>
)

export default Categories
